import { render } from "./AddIcon.vue?vue&type=template&id=6bd2f4c5"
import script from "./AddIcon.vue?vue&type=script&lang=js"
export * from "./AddIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__